import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="mx-auto max-w-3xl text-center" data-id="element-71" data-mp="3k06x1v86utys">
      {eyebrow && <p className={`text-sm font-extrabold uppercase tracking-[0.14em] ${dark ? "text-gold" : "text-brand"}`} data-id="element-72" data-mp="3k29j646802y8">{eyebrow}</p>}
      <h2 className={`mt-3 text-[1.9rem] font-extrabold leading-[1.12] tracking-tight sm:text-5xl ${dark ? "text-white" : "text-navy"}`} data-id="element-73" data-mp="gj6sv5her3gb">
        {title}
      </h2>
      {intro && <div className={`mt-5 text-lg leading-relaxed ${dark ? "text-brand-sky" : "text-muted"}`} data-id="element-74" data-mp="6tn9lyps97kx">{intro}</div>}
    </div>;
}